/**
 * Enumeration representing custom icons used in the lemunzo project.
 * Each enum member corresponds to a specific icon identifier, located in the assets/img folder.
 */
export enum CustomIconsEnum {
    ADD = 'add',
    CALENDAR = 'calendar',
    CARET_DOWN = 'caret-down',
    CARET_LEFT = 'caret-left',
    CARET_RIGHT = 'caret-right',
    CARET_UP = 'caret-up',
    CHECK = 'check',
    CHECKBOX_SELECTED = 'checkbox-selected',
    CHECKBOX_UNSELECTED = 'checkbox-unselected',
    CROSS = 'cross',
    DELETE = 'delete',
    DOCUMENT = 'document',
    EMAIL = 'email',
    GET_COMPENSATED = 'get-compensated',
    HELP = 'help',
    LOG_IN = 'log-in',
    LOG_OUT = 'log-out',
    MENU = 'menu',
    NOTIFICATION = 'notification',
    OVERVIEW = 'overview',
    RELOAD = 'reload',
    SEARCH = 'search',
    SETTINGS = 'settings',
    STEP_BACK = 'step-back',
}
